<!-- PCB文件 -->
<template>
  <div class="pcbfile">
    <el-upload
      drag
      ref="uploadRefs"
      name='file'
      :accept='accept'
      class="pcbfile-upload"
      :class="{ 'pcbfile-upload--fail': status === 3, 'is-error': isError, 'is-shake': isShake }"
      :action="url"
      :show-file-list="false"
      :before-upload="handleBeforeUpload"
      :on-progress="handleOnProgress"
      :on-success="handleOnSuccess"
      :on-error="handleOnError"
    >
      <!-- 未开始 -->
      <div v-if="status === 0" class="pcbfile-upload__notStarted">
        <div class="notStarted-btn">
          <img :src="require('@@/assets/img/icons/icon_upload5.png')" />
          <span>上传Gerber/PCB文件</span>
        </div>
        <div class="notStarted-text">
          拖拽文件到此 (或点击上传)，系统将<em>自动解析</em>计价参数
        </div>
        <p  class="notStarted-tips">
          压缩包格式 (zip, rar)，小于50MB；暂不支持：CAD, Allegro, Gerber274-D, Protel98(及以下版本)的文件
        </p>
      </div>
      <!-- 上传中 -->
      <div v-if="status === 1" class="pcbfile-upload__uploading" @click.stop>
        <div class="pcbfile-upload__item is-default">
          <p>{{ name }}</p>
          <span>{{ viewSize }}</span>
        </div>
        <div class="uploading-progress">
          <p>
            上传中
            <span>{{ upload.progress }}%</span>
          </p>
          <el-progress
            color="#3F96F0"
            text-color="#FFFFFF"
            define-back-color="#D6D6D6"
            :stroke-width="6"
            :text-inside="false"
            :percentage="upload.progress"
          ></el-progress>
        </div>
      </div>
      <!-- 上传成功 解析中 -->
      <div v-if="status === 2" class="pcbfile-upload__success" @click.stop>
        <div class="pcbfile-upload__item is-active">
          <p>{{ name }}</p>
          <span>{{ viewSize }}</span>
        </div>
        <div class="success-analyzeing">
          <p>
            <i class="el-icon-circle-check" />
            上传成功
          </p>
          <div>
            <i class="el-icon-refresh-left" />
            文件解析中
            <span>(预计{{ analyze.countdown }}秒后解析完成)</span>
          </div>
        </div>
      </div>
      <!-- 上传失败 -->
      <div v-if="status === 3" class="pcbfile-upload__fail" @click.stop>
        <div class="pcbfile-upload__item is-error">
          <p>{{ name }}</p>
          <span>{{ viewSize }}</span>
        </div>
        <div class="fail-tips">
          <div class="fail-tips__text">
            <i class="el-icon-error" />
            <span>上传失败</span>
            <p>{{ errorMsg }}服务器返回的失败原因</p>
          </div>
          <div class="fail-tips__btns">
            <el-button 
              round 
              size="mini" 
              class="pcbfile-upload__button reupload is-error" 
              @click="handleClick"
            >重新上传</el-button>
            <el-button 
              round 
              size="mini" 
              class="pcbfile-upload__button reset" 
              @click="handleReset"
            >重置</el-button>
          </div>
        </div>
      </div>
      <!-- 解析成功 -->
      <div v-if="status === 4" class="pcbfile-upload__analyze" @click.stop>
        <p v-if="analyze.list.length > 1" class="pcbfile-upload__analyze__tips">
          {{ multipleFilesTips || '识别到压缩包内有多个PCB文件，可手动选择要下单的文件' }}
        </p>
        <div 
          v-for="item in analyze.list" 
          :key="item.key"
          :class="{ 'pcbfile-upload__item': true, 'is-active': analyze.currentKey == item.key }"
          @click="handleAnalyzeChange(item.key)"
        >
          <p>{{ item.name }}</p>
        </div>
        <!-- 多文件切换文件解析中 -->
        <template v-if="analyze.analyzeing">
          <div class="analyze-analyzeing">
            <i class="el-icon-refresh-left" />
            文件解析中
            <span>(预计{{ analyze.countdown }}秒后解析完成)</span>
          </div>
        </template>
        <!-- 解析完成 -->
        <template v-else>
          <div :class="`analyze-completed ${analyze.result ? 'success' : 'fail'}`">
            <!-- 有解析数据 -->
            <div v-if="analyze.result" class="analyze-completed__success">
              <i class="el-icon-circle-check"/>
              <em>解析成功，相关参数已自动填充；</em>
              <span>为确保信息无误，请核对后下单</span>
            </div>
            <!-- 没解析数据 -->
            <div v-else class="analyze-completed__fail">
              <i class="el-icon-warning-outline"/>
              <em>解析失败</em>
              <span>无法解析参数 (不影响下单)，请手动填写参数后下单</span>
            </div>
            <div>
              <el-button 
                round 
                size="mini" 
                class="pcbfile-upload__button reupload" 
                @click="handleClick"
              >重新上传</el-button>
              <el-button 
                round 
                size="mini" 
                class="pcbfile-upload__button reset" 
                @click="handleReset"
              >重置</el-button>
            </div>
          </div>
        </template>
      </div>
      <!-- 解析失败 -->
      <div v-if="status === 5" class="pcbfile-upload__analyze" @click.stop>
        <div class="pcbfile-upload__item is-active">
          <p>{{ name }}</p>
        </div>
        <div class="analyze-completed fail">
          <div class="analyze-completed__fail">
            <i class="el-icon-warning-outline"/>
            <em>解析失败</em>
            <span>无法解析参数 (不影响下单)，请手动填写参数后下单</span>
          </div>
          <div>
            <el-button 
              round 
              size="mini" 
              class="pcbfile-upload__button reupload" 
              @click="handleClick"
            >重新上传</el-button>
            <el-button 
              round 
              size="mini" 
              class="pcbfile-upload__button reset" 
              @click="handleReset"
            >重置</el-button>
          </div>
        </div>
      </div>
      <!-- 修改回显 -->
      <div v-if="status === 6" class="pcbfile-upload__view" @click.stop>
        <div class="pcbfile-upload__item is-active">
          <p>{{ name }}</p>
        </div>
        <div class="pcbfile-upload__view__btns">
          <el-button 
            round 
            size="mini" 
            class="pcbfile-upload__button reupload" 
            @click="handleClick"
          >重新上传</el-button>
          <el-button 
            round 
            size="mini" 
            class="pcbfile-upload__button reset" 
            @click="handleReset"
          >重置</el-button>
        </div>
      </div>
    </el-upload>
  </div>
</template>

<script>
import { sensorsTrack } from '@@/utils/sensors'
import {
  HQPCB_HOST,
  fileAnalyzeResult
} from '@@/api/pcb'

// 上传
const defaultUpload = {
  progress: 0, // 上传进度百分比
  timer: null, // 上传进度百分比定时器
}
// 解析
const defaultAnalyze = {
  analyzeing: false, //解析中
  progress: 0, // 解析进度百分比
  timer: null, // 解析进度百分比定时器
  currentKey: 0, 
  list: [], // 解析成功列表
  analyzeTimer: null, // 解析接口定时器
  countdown: 60, // 解析倒计时
  countdownTimer: null, // 倒计时定时器
  timeConstant: 5000, // 进度条变化的快慢，数字越大，变化的越慢
  result: null, // 解析成功的数据
}

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    analyze_id: {
      type: String,
      default: ''
    },
    analyzeKey: {
      type: Number,
      default: 0
    },
    // PCB文件名称
    pcbFileName: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: '.zip,.rar'
    }
  },
  data() {
    return {
      val: this.value,
      analyzeId: this.analyze_id, // 上传成功后返回的id
      url: `${HQPCB_HOST}/upfile?type=gerber&full_url=1`,
      status: 0, // 状态： 0-未开始, 1-上传中, 2-上传成功, 3-上传失败, 4-解析成功, 5-解析失败, 6-修改回显
      name: '', // 文件名称
      size: 0, // 单位B
      errorMsg: '', // 上传失败提示
      upload: { ...defaultUpload },
      analyze: { ...defaultAnalyze },
      multipleFilesTips: '', // 多个文件提示
      isError: false, // 是否显示错误提示样式
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    // 文件大小
    viewSize() {
      const size = this.size
      let text = size + ' B'
      if (size > 1024) {
        text = parseInt(size / 1024) + ' KB'
      }
      if (size > 1024 * 1024) {
        text = parseInt(size / (1024 * 1024)) + ' MB'
      }
      return text
    },
  },
  watch: {
    value(newVal) {
      this.val = newVal
      if (newVal && this.status === 0) {
        this.name = this.pcbFileName || newVal.split('/').pop()
        this.status = 6
      }
    },
  },
  methods: {
    handleEmit() {
      const { val, name, analyzeId, analyze } = this
      this.$emit('input', val)
      this.$emit('change', val)
      this.$emit('update:analyze_id', analyzeId)
      this.isError = false
    },
    handleEmitAnalyzeKey(key) {
      this.$emit('update:analyze_key', key)
    },

    handleClick() {
      this.$refs.uploadRefs.$refs['upload-inner'].handleClick()
    },
    // 重置
    handleReset(event) {
      event && event.stopPropagation()
      this.status = 0
      this.name = ''
      this.size = 0
      this.analyzeId = ''
      this.upload = { ...defaultUpload }
      this.analyze = { ...defaultAnalyze }
      this.val = ''
      this.multipleFilesTips = ''
      this.isError = false
      this.handleEmit()
    },

    // 上传校验
    handleBeforeUpload(file) {
      const { name, size } = file
      const isLimit50M = size / 1024 / 1024 < 50
      if (isLimit50M) {
        this.status = 1
        this.upload.progress = 0
        this.analyze.progress = 0
        this.size = size
        this.name = name
      } else {
        this.$message.error('文件大小不能超过 50MB，请重新上传！')
      }
      return isLimit50M
    },
    // 上传中
    handleOnProgress(event, file) {
      // 神策数据埋点
      sensorsTrack('PCB1_quotation_UploadGerber_click', { entrance: '新版PCB计价：上传文件' })

      const toFixed_1 = val => Number(val.toFixed(1))
      // 上传进度条处理
      const percent = toFixed_1(event.percent * 0.95)
      this.upload.progress = Number(percent)
      if (event.percent == 100) {
        this.upload.timer = setInterval(() => {
          if (this.upload.progress < 100) {
            const random = toFixed_1(Math.floor(Math.random() * 10) * 0.1)
            this.upload.progress = toFixed_1(this.upload.progress + random)
          }
        }, 300)
      }
    },
    // 上传成功
    handleOnSuccess(res) {
      const { status, url, name, analyze_id, msg } = res
      if (status) {
        this.upload.progress = 100
        const timer = setTimeout(() => {
          this.analyzeId = analyze_id
          this.val = url
          this.handleEmit()

          this.status = 2
          this.startAnalyze()
          clearTimeout(timer)
        }, 400)
      } else {
        this.upload.progress = 0
        this.analyze.progress = 0
        this.status = 3
        this.errorMsg = msg
      }
    },
    // 上传失败
    handleOnError() {
      this.status = 3
      this.handleReset()
    },

    handleAnalyzeChange(key) {
      this.$nextTick(() => {
        this.multipleFilesTips = '识别到压缩包内有多个PCB文件，请注意不要选错了'
        this.analyze.currentKey = key
        this.startAnalyze(key)
      })
    },
    // 文件解析
    startAnalyze(key) {
      this.handleEmitAnalyzeKey(key || 0)
      this.startCountdown()
      this.startProgress()
      this.analyze.analyzeing = true
      this.analyze.analyzeTimer = setInterval(() => {
        const params = { analyze_id: this.analyzeId }
        fileAnalyzeResult(params, key)
          .then(res => {
            if (!res) return
            const { code, data = {} } = res
            if (code == 200) {
              const { items = [], key, result } = data
              this.analyze.currentKey = key
              this.analyze.list = items
              this.handleEmitAnalyzeKey(key)
              // 解析失败
              if (items.every(i => i.status != 1 && i.status !== 0)) {
                this.status = 5
                this.endAnalyze(5)
                return
              }

              this.analyze.result = result
              // 数据解析成功
              if (result) {
                // 如果解析出来是3层板，则设为4层
                if (result.blayer == 3) {
                  result.blayer = 4
                }
                result.file_type = result.fileType
              }

              this.endAnalyze(4)
              this.$emit('analyzeSuccess', result || { file_type: -1 })
            }
            if (code < 105) {
              this.analyzeFailed()
            }
          })
          .catch(err => {})
      }, 1500)
    },
    // 解析完成：4-解析成功 5-解析失败
    endAnalyze(status) {
      clearInterval(this.analyze.analyzeTimer)
      this.endProgress()
      this.endCountdown()
      this.analyze.analyzeing = false
      const timer = setTimeout(() => {
        this.status = status
        clearTimeout(timer)
      }, 500)
    },
    // 解析失败
    analyzeFailed() {
      this.endAnalyze(5)
      this.$emit('analyzeSuccess', { file_type: -1 })
    },
    // 开始倒计时
    startCountdown() {
      this.analyze.countdown = 60
      this.analyze.countdownTimer = setInterval(() => {
        this.analyze.countdown--
        // 解析时间超过60秒没结果则按解析失败处理
        if (this.analyze.countdown <= 0) {
          this.analyzeFailed()
        }
      }, 1000)
    },
    // 结束倒计时
    endCountdown() {
      clearInterval(this.analyze.countdownTimer)
      this.analyze.countdownTimer = null
    },
    // 解析进度条进度 开始
    startProgress() {
      // 定时器间隔
      const frequency = 100
      let time = 0
      this.analyze.progress = 0
      this.analyze.timer = setInterval(() => {
        time += frequency
        if (this.analyze.progress >= 1) {
          this.endProgress()
          return
        }
        this.analyze.progress = 1 - Math.exp((-1 * time) / this.analyze.timeConstant)
      }, frequency)
    },
    // 解析进度条进度 结束
    endProgress() {
      this.analyze.progress = 1
      clearInterval(this.analyze.timer)
      this.analyze.timer = null
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';

.pcbfile-upload ::v-deep {
  margin-bottom: 14px;

  .el-upload {
    display: block;
    color: $--color-text-primary;
    &:focus {
      color: $--color-text-primary;
    }
    .el-upload-dragger {
      width: 100%;
      height: auto;
      line-height: 1;
      text-align: left;
      font-size: 14px;
      border: 0;
      border-radius: $--border-radius-base2;
    }
  }

  .pcbfile-upload__item {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 16px 0 12px;
    width: 100%;
    height: 42px;
    border: 1px solid #E1E1E1;
    border-radius: $--border-radius-base2;
    background-color: #FFF;
    & + .pcbfile-upload__item { 
      margin-top: 6px;
    }
    &::before {
      content: '';
      display: block;
      width: 18px;
      height: 14px;
      background: url('~@@/assets/img/icons/icon_file.png');
    }
    &.is-default {
      border: 1px solid #f8f8f8;
      background: #f8f8f8;
      >p {
        font-weight: 700;
      }
    }
    &.is-active {
      position: relative;
      border-color: #15A675;
      background-color: #F7FCFB;
      &::before {
        background: url('~@@/assets/img/icons/icon_file_active.png');
      }
      &::after { 
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        display: block;
        width: 20px;
        height: 14px;
        background: url('~@@/assets/img/icons/icon_radio.png');
      }
      >p {
        height: 14px;
        font-weight: 700;
      }
    }
    &.is-error {
      border-radius: $--border-radius-base2;
      border: 1px dashed $--color-danger;
      background-color: #fef0f0;
      >p {
        font-weight: 700;
      }
    }
    &:hover {
      border-color: #AAAAAA;
      background-color: #FDFDFD;
      &::before {
        background: url('~@@/assets/img/icons/icon_file_hover.png');
      }
      &::after {
        display: none;
      }
      >p {
        font-weight: 700;
      }
    }
    >p {
      flex: 1;
      margin: 0 8px;
      width: 600px;
      font-size: 12px;
      color: #111111;
      @include ellipsis;
    }
    >span {
      display: block;
      width: 60px;
      font-size: 12px;
      color: #AAAAAA;
      text-align: right;
    }
  }

  .pcbfile-upload__button {
    font-size: 12px;
    color: #555555;
    border-color: #F8F8F8;
    background-color: #F8F8F8;
    &.reupload:hover {
      color: $--form-color-base;
    }
    &.reset:hover {
      color: $--color-danger;
    }
    &.is-error {
      color: #FFF;
      border-color: #FF4D4F;
      background-color: #FF4D4F;
      &:hover {
        color: #FFF;
        border-color: #EE4648;
        background-color: #EE4648;
      }
    }
  }

  .pcbfile-upload__notStarted {
    padding: 27px 0 24px;
    text-align: center;
    border-radius: $--border-radius-base2;
    border: 1px dashed #61C3A2;
    background-color: #F7FCFB;
    &:hover {
      border-color: #15A675;
      background-color: #F2FAF9;
    }
    .notStarted-btn {
      display: inline-block;
      width: 235px;
      height: 36px;
      line-height: 36px;
      font-weight: 700;
      color: #FFF;
      border-radius: 18px;
      background: $--form-color-base;
      >img {
        display: inline-block;
        margin-right: 8px;
        vertical-align: text-bottom;
      }
    }
    .notStarted-text {
      margin: 13px 0 8px;
      line-height: 18px;
      color: #555;
      >em {
        color: $--color-warning;
        font-style: normal;
      }
    }
    .notStarted-tips {
      line-height: 18px;
      font-size: 13px;
      color: #888;
    }
  }

  .pcbfile-upload__uploading {
    .uploading-progress {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      margin-top: 10px;
      padding: 0 14px 0 12px;
      height: 28px;
      border-radius: 14px;
      background-color: #f4f9ff;
      >p {
        margin-right: 16px;
        width: 82px;
        font-size: 12px;
        color: #3F96F0;
      }
      .el-progress {
        flex: 1;
        height: 16px;
        .el-progress-bar {
          padding-right: 0;
        }
      }
    }
  }

  .pcbfile-upload__success {
    .success-analyzeing {
      display: flex;
      align-items: center;
      margin-top: 10px;
      >p {
        margin-right: 6px;
        width: 98px;
        height: 28px;
        line-height: 28px;
        font-size: 12px;
        color: #67C23A;
        text-align: center;
        border-radius: 14px;
        background-color: #f8f8f8;
        >i {
          font-size: 14px;
          vertical-align: text-bottom;
        }
      }
      >div {
        flex: 1;
        padding-left: 13px;
        height: 28px;
        line-height: 28px;
        font-size: 12px;
        color: #3F96F0;
        border-radius: 14px;
        background: linear-gradient(270deg,#ffffff 2%, #f4f9ff 89%);
        >i {
          font-size: 14px;
          vertical-align: text-bottom;
          animation: spin 1s linear infinite;
        }
        >span {
          color: #999999;
        }
      }
    }
  }

  .pcbfile-upload__fail {
    .fail-tips {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      padding-left: 13px;
      border-radius: 14px;
      font-size: 12px;
      background: linear-gradient(90deg,#fef0f0 2%, #ffffff 89%);
      .fail-tips__text {
        display: flex;
        >i {
          font-size: 14px;
          color: $--color-danger;
        }
        >span {
          margin: 0 10px 0 5px;
          font-weight: 700;
          color: $--color-danger;
        }
        >p {
          color: #999999;
        }
      }
    }
  }

  .pcbfile-upload__analyze {
    .pcbfile-upload__analyze__tips {
      margin-bottom: 9px;
      font-size: 12px;
      color: #C08534;
    }
    .analyze-analyzeing {
      margin-top: 10px;
      padding-left: 13px;
      height: 28px;
      line-height: 28px;
      font-size: 12px;
      color: #3F96F0;
      border-radius: 14px;
      background: linear-gradient(270deg,#ffffff 2%, #f4f9ff 89%);
      >i {
        font-size: 14px;
        vertical-align: text-bottom;
        animation: spin 1s linear infinite;
      }
      >span {
        color: #999999;
      }
    }
    .analyze-completed {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      padding-left: 13px;
      font-size: 12px;
      border-radius: 14px;
      &.success {
        background: linear-gradient(270deg,#ffffff 2%, #f8f8f8 89%);
      }
      &.fail {
        background: linear-gradient(270deg,#ffffff 2%, #fff4e3 89%);
      }
      .analyze-completed__success {
        font-size: 12px;
        >i {
          margin-right: 6px;
          font-size: 14px;
          color: #75C84D;
          vertical-align: text-bottom;
        }
        >em {
          color: #555555;
          font-style: normal;
        }
        >span {
          color: #999999;
        }
      }
      .analyze-completed__fail {
        font-size: 12px;
        >i {
          font-size: 14px;
          color: #C08534;
          vertical-align: text-bottom;
        }
        >em {
          margin: 0 8px 0 6px;
          color: #C08534;
          font-style: normal;
        }
        >span {
          color: #999999;
        }
      }
    }
  }

  .pcbfile-upload__view {
    .pcbfile-upload__view__btns {
      margin-top: 10px;
      text-align: center;
    }
  }

  // 转圈动画
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }
}

.pcbfile-upload.is-error {
  position: relative;
  &::before {
    position: absolute;
    top: -3px;
    left: -3px;
    z-index: 10;
    content: '';
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: $--color-danger;
    box-shadow: 0 0 5px $--color-danger;
    animation: pulse 1.2s infinite;
  }
  .pcbfile-upload__notStarted {
    border-color: $--color-danger;
    background-color: #FEF0F0;
    .notStarted-btn {
      background-color: $--color-danger;
    }
  }
  // 错误红点闪烁
  @keyframes pulse {
    0% {
      transform: scale(.95);
      box-shadow: 0 0 #ff4d4fb3;
    }
    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px #ff4d4f00;
    }
    to {
      transform: scale(.95);
      box-shadow: 0 0 #ff4d4f00;
    }
  }
}

.pcbfile-upload.is-error.is-shake {
  @include shakeAnimation;
}
</style>